import Message from "../sections/message";
import { getStringFromLocalStorage } from "../services/localStorage";
import {
  RoutePage,
} from "../types";

export class Page {
  public message: Message;
  public apiUrl = import.meta.env.VITE_API_URL as string;
  public apiToken = getStringFromLocalStorage("idToken");
  constructor(pageContent: string) {
    document.querySelector<HTMLDivElement>("#app")!.innerHTML = pageContent;
    this.message = new Message();
  }

  async init(): Promise<void> {
  }

  handleCustomAttributes(): void {
    // Handle ToggleSections (button with div as child, clicking button toggles 'hidden' class)
    const toggleSections = document.querySelectorAll("[data-toggle-section]");
    toggleSections.forEach((toggleSection) => {
      const toggleSectionName = toggleSection.attributes.getNamedItem("data-toggle-section")?.value;
      toggleSection.addEventListener("click", () => {
        console.log(`getting section '${toggleSectionName}_hideable'`);
        const section = document.getElementById(`${toggleSectionName}_hideable`) as HTMLDivElement;
        section.classList.toggle("hidden");
      });

      // Handle Data Models (input with value that is kept in state as it changes)
      // const dataModels = document.querySelectorAll("[data-model]");
      // dataModels.forEach((dataModel) => {
      //   const storeName = dataModel.attributes.getNamedItem("data-store")?.value;
      //   const storeKey = dataModel.attributes.getNamedItem("data-model")?.value;
      //   dataModel.addEventListener("change", () => {
      //     this.store.set()
      //   })
      // });
    });
  }
}

export enum Pages {
  LOGIN = "login",
  REGISTER = "register",
  HOME = "home",
  NOTFOUND = "notfound",
  PROFILE = "profile",
  PROFILER = "profiler",
}

export const RoutePages: RoutePage[] = [
  {
    path: "",
    page: Pages.HOME,
  },
  {
    path: "/home",
    page: Pages.HOME,
  },
  {
    path: "/404",
    page: Pages.NOTFOUND,
  },
  {
    path: "/login",
    page: Pages.LOGIN,
  },
  {
    path: "/register",
    page: Pages.REGISTER,
  },
  {
    path: "/profile",
    page: Pages.PROFILE,
  },
  {
    path: "/profiler",
    page: Pages.PROFILER,
  }
];
